import React, {Component} from "react";
import {connect} from "react-redux";
import PanelGroupController from "../../components/PanelGroupController";
import {cx} from "../../lib/ClassSet";
import gql from "graphql-tag";
import {graphql} from "react-apollo";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS} from "immutable";
import update from "immutability-helper";
import {dateWithTimeFormat} from "../../lib/DateFormatter";
import "./LogPanel.scss";

class LogPanel extends Component {

  componentDidMount() {
    if (this.props.subscriptionId) {
      this.subscribe(this.props);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.subscriptionId && (prevProps.subscriptionId !== this.props.subscriptionId)) {
      this.subscribe(this.props);
    }
  }

  subscribe(props) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToMore(props, {});
  }  


  render() {
    let {loading, error, subscriptionLog} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let items = fromJS(subscriptionLog);

    let elements = items.map(x => {
      return <LogItem key={x.get("eventId")} data={x} />
    })

    let classes = cx({
      "LogPanel": true,
      "u-limitHeight": this.props.limitHeight
    })    

    return (
      <div className={classes}>
        <PanelGroupController title="Event Log" expanded={true}>
          {elements}
        </PanelGroupController>
      </div>
    )
  }

}


const LOG = gql`
  query subscriptionLog($filter:SubscriptionLogFilterInput!) {
    subscriptionLog(filter: $filter) {
      subscriptionId
      deliveryId
      eventId
      eventType
      description
      isError
      transient
      errorCode
      occuredAt
    }
  }
`

const LOG_SUBSCRIPTION = gql`
  subscription onLogUpdated($subscriptionId:ID!) {
    updatedSubscriptionLog(subscriptionId: $subscriptionId) {
      subscriptionId
      eventId
      eventType
      description
      isError
      transient
      errorCode
      occuredAt      
    }
  }
`


const withQuery = graphql(LOG, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: {
        subscriptionId: props.subscriptionId
      }
    }
  })
})

const mapDispatchToProps = dispatch => ({
  subscribeToMore: (props, params) => {
    return props.data.subscribeToMore({
      document: LOG_SUBSCRIPTION,
      variables: {
        subscriptionId: props.subscriptionId
      },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          shippingOrderLog: {
            $unshift: [subscriptionData.data.updatedSubscriptionLog]
          }
        })
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

LogPanel.defaultProps = {
  limitHeight: true
}

export default withQuery(withSubscription(LogPanel));



const LogItem = (props) => {

  let data = props.data;
  let code = data.get("isError") ? "Err" : "Ok";

  let classes = cx({
    "item": true,
    "u-error": data.get("isError")
  })

  var rxp = /\[([a-z_]+):([0-9a-z \-_:]+)\]/gi;
  let markup = {__html: data.get("description").replace(rxp, '<span>$2</span>')};

  return (
    <div className={classes}>
      <div className="header">
        <div className="result">{code}</div>
        <div>
          <div className="description" dangerouslySetInnerHTML={markup}/>
          <span className="occuredAt">{dateWithTimeFormat(data.get("occuredAt"))}</span>
        </div>
      </div>
    </div>
  )

}